import React, {Component} from 'react';
import {Table} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar'

class ResponsiveTable extends Component {
  render() {
    return (
      <PerfectScrollbar>
        <Table className="align-items-center table-flush" striped>
          {this.props.children}
        </Table>
      </PerfectScrollbar>
    )
  }
}

export {ResponsiveTable};
